import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StepsEnum } from '../models/steps.enum';

@Injectable({
  providedIn: 'root'
})
export class StepTitleStrategyService {
  readonly #stepTitles = new Map<StepsEnum, string>([
    [StepsEnum.INTRODUCTION, 'Return on College – Make Informed Education Decisions'],
    [StepsEnum.BACKGROUND, 'Return on College – Your Background'],
    [StepsEnum.COLLEGE_COSTS, 'Return on College – Your College Costs'],
    [StepsEnum.COLLEGE_FUNDING, 'Return on College – Your College Funding'],
    [StepsEnum.COLLEGE_ROI_REPORT, 'Return on College – Your College ROI Report']
  ]);

  #currentStep: StepsEnum | null = null;

  constructor(
    private title: Title,
    private router: Router
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe({next: () =>this.#updateTitle()});
  }

  public setCurrentStep(step: StepsEnum): void {
    this.#currentStep = step;
    this.#updateTitle();
  }

  #updateTitle(): void {
    if (this.#currentStep && this.#stepTitles.has(this.#currentStep)) {
      const title = this.#stepTitles.get(this.#currentStep)!;
      this.title.setTitle(title);
    }
  }
}
